let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bA0K4")).then(() => parcelRequire('a5cvw'));